import StyleBase from '../../../styles/base';

const styles: any = {
  calendarEventBox: {
    borderRadius: 10,
    fontSize: 8,
    '&:hover': {
      color: 'black',
      cursor: 'pointer',
    },
  },
  calendarEventPendingBox: {
    backgroundColor: '#FFD750',
    color: 'black',
  },
  calendarEventConfirmedBox: {
    backgroundColor: '#195A50',
    color: 'white',
  },
  calendarEventOpenhouseConfirmed: {
    backgroundColor: '#463264',
    color: 'white',
  },
  calendarEventOpenHouse: {
    border: '1px solid #463264',
    backgroundColor: '#fffff',
    color: '#463264',
  },
  calendarEventDisabled: {
    backgroundColor: '#E2E2E2',
    color: '#636363',
    '&:hover': {
      backgroundColor: '#E2E2E2',
      color: '#636363',
      cursor: 'default',
    },
  },
  upcomingShowingsBox: {
    padding: 10,
    backgroundColor: '#FAF8FB',
    borderRadius: 8,
    minWidth: 200,
    margin: '20px 8px 20px 0',
    textAlign: 'left',
    overflowY: 'scroll',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    [StyleBase.media.tablet]: {
      maxHeight: 450,
    },
    [StyleBase.media.mobile]: {
      margin: '20px 10px 20px 10px',
      maxHeight: 300,
    },
  },
  upcomingTitle: {
    fontSize: 11,
    fontFamily: 'Sharp Grotesk Semibold !important',
    margin: '4px 0',
  },
  showingContentBox: {
    margin: '4px 0 10px',
    paddingBottom: 10,
    borderBottom: '1px solid #E2E2E2',
  },
  showingDetailsFirstLine: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  showingStatusDot: {
    height: 8,
    width: 8,
    borderRadius: '50%',
    backgroundColor: '#FF7350',
  },
  showingDate: {
    fontSize: 12,
    fontFamily: 'Poppins',
    fontWeight: 'bold',
    margin: '0 4px',
  },
  showingAddress: {
    fontSize: 10,
    fontFamily: 'Poppins',
    margin: '4px 0',
  },
};

export default styles;
